import React, { useState, useEffect, useRef } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import storeFunction from "../utils/storeFunction";

const HeaderImage = ({ 
  image, 
  preset, 
  placeholderRectangle,
  breakpointWidth,
  breakpointHeight,
  fixedWidth,
  fixedHeight,
}) => {
  const containerRef = useRef(null);
  const isFixedImage = fixedWidth && fixedHeight

  const [dimensions, setDimensions] = useState({
    width: fixedWidth || breakpointWidth,
    height: fixedHeight || breakpointHeight,
  });

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        let height = breakpointHeight;

        if (preset.app_brand_stylesheet) {
          if (containerWidth <= breakpointWidth) {
            height = Math.min(containerWidth * 0.6, breakpointHeight);
            height = Math.max(height, breakpointHeight);
          } else {
            height = Math.min(containerRef.current.offsetHeight, breakpointHeight);
            height = Math.max(height, breakpointHeight);
          }
        }

        setDimensions({
          width: containerWidth,
          height,
        });
      }
    };

    updateDimensions(); // Initial calculation
    if (!isFixedImage)
      window.addEventListener('resize', updateDimensions);
    return () => (!isFixedImage) && window.removeEventListener('resize', updateDimensions);
  }, [preset.app_brand_stylesheet, breakpointWidth, breakpointHeight, isFixedImage]);

  if (!image) return null;

  return (
    <div 
      ref={containerRef}
      className="sectionHeaderImage" 
      style={{ 
        textAlign: 'center',
        margin: '0 auto',
        overflow: 'hidden',
        height: `${dimensions.height}px`,
        ...(fixedWidth ? { width: `${fixedWidth}px` } : { width: '100%' }),
      }}
    >
      <LazyLoadImage
        alt="header image"
        placeholderSrc={placeholderRectangle}
        src={isFixedImage ? storeFunction.resizeImage(image, fixedWidth, fixedHeight) : image }
        width="100%"
        style={{
          minHeight: `${dimensions.height}px`,
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
    </div>
  );
};

export default HeaderImage;
